import React from 'react';
import { useLocation } from 'react-router-dom';
import './styles/StartNavigationScreen.css';
import { FaMapMarkedAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
const StartNavigationScreen = () => {
    const navigate = useNavigate();
  const { state } = useLocation();

  if (!state || !state.vendorLat || !state.shopAddress) {
    return <div className="navigation-error">Location or destination not provided.</div>;
  }

  const { location,vendorLat,vendorLng, shopAddress, shopName } = state;

  const openGoogleMaps = () => {
    const start = `${ vendorLat},${ vendorLng}`;
    const encodedDestination = encodeURIComponent(shopAddress);
    const mapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${start}&destination=${encodedDestination}&travelmode=driving`;

    window.open(mapsUrl, '_blank');
  };

  return (
    <div className="navigation-container">
      <h2>🧭 Start Navigation</h2>

      <div className="navigation-info">
        <p><strong>From:</strong> 📍 Your Location<br />{vendorLat}, {vendorLng}</p>
        <p><strong>To:</strong> 🏪 {shopName}<br />{shopAddress}</p>
      </div>

      <button className="btn start-nav" onClick={openGoogleMaps}>
        <FaMapMarkedAlt style={{ marginRight: '8px' }} />
        Start Navigation
      </button>
    </div>
  );
};

export default StartNavigationScreen;
